export const GTM_UNIQUE_EVENT_ID = 'gtm.uniqueEventId';

export interface DataLayerEvent {
  event?: string;
  [key: string]: any;
}

export type GtmInteractor = {
  push: (event: DataLayerEvent) => void;
  pushOnce(event: Record<string, unknown>): any;
};

export function createGtmInteractor(dataLayerName: string) {
  let pushedOnceEvents: string[] = [];

  const getDataLayer = () => {
    const dataLayer = (window as any)[dataLayerName];
    // UserCentics may remove/override dataLayer
    return (Array.isArray(dataLayer) ? dataLayer : []) as DataLayerEvent[];
  };

  const push = (event: DataLayerEvent) => {
    getDataLayer().push(event);
  };

  const pushOnce = (event: DataLayerEvent) => {
    if (event.event && !pushedOnceEvents.includes(event.event)) {
      pushedOnceEvents = [...pushedOnceEvents, event.event];
      getDataLayer().push(event);
    }
  };

  return {
    push,
    pushOnce,
  };
}
